<div class="card badges-container" style="padding: 25px; display: flex;">
    <img [class.badge-dark]="!this.readerBadge" src="../../../assets/badges/beta_reader.png" alt="Beta reader badge">
    <img [class.badge-dark]="!this.writerBadge" src="../../../assets/badges/writer.png" alt="Writer badge">
    <img [class.badge-dark]="!this.superheroBadge" src="../../../assets/badges/superhero.png" alt="Writer badge">
    <span *ngFor="let badgeKey of this.badge | keyvalue"><img [class.badge-dark]="!this.user.getAwardedBadge(badgeKey.key)" [src]="this.badge[badgeKey.key].imgUrl"></span>
</div>
<div>
    <p-button label="Earn Beta Tester Badge" (onClick)="earnBetaBadge()"></p-button>
</div>
